module.exports = __webpack_public_path__ + "assets/icon-csat-star-component.8fc96fbd.svg";